import { ArrowUpRight, Check } from "lucide-react";
import { Reveal } from "./Reveal";

const COUNTRIES = [
  {
    id: "usa", name: "United States", flag: "USA",
    img: "https://images.pexels.com/photos/5554240/pexels-photo-5554240.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    highlights: ["Post-study work permit up to 3 years (STEM OPT)", "Ivy League & top-100 global universities", "Assistantships & merit scholarships"],
    fees: "$20k – $55k / yr",
  },
  {
    id: "uk", name: "United Kingdom", flag: "UK",
    img: "https://images.pexels.com/photos/31466977/pexels-photo-31466977.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    highlights: ["Tier-1 research universities", "1-year master's degrees", "Graduate Route: 2-year work visa"],
    fees: "£15k – £35k / yr",
  },
  {
    id: "germany", name: "Germany", flag: "Germany",
    img: "https://images.pexels.com/photos/33247025/pexels-photo-33247025.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    highlights: ["Low or zero tuition at public universities", "STEM & engineering pathways", "18-month post-study job seeker visa"],
    fees: "€0 – €20k / yr",
  },
  {
    id: "latvia", name: "Latvia", flag: "Latvia",
    img: "https://images.pexels.com/photos/17175567/pexels-photo-17175567.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    highlights: ["Affordable English-taught programs", "Schengen mobility across Europe", "Fast admissions & visa processing"],
    fees: "€3k – €8k / yr",
  },
];

export const Destinations = ({ onEnquire }) => (
  <section id="destinations" data-testid="destinations-section" className="py-20 lg:py-28 bg-white border-t border-slate-900/10">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <Reveal>
        <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.18em] text-amber-800">01 — Destinations</p>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0B192C] mt-3 max-w-2xl leading-[1.05]">
          Four destinations. <em className="italic text-amber-600">One</em> guided journey.
        </h2>
      </Reveal>
      <div className="grid sm:grid-cols-2 gap-6 lg:gap-8 mt-14">
        {COUNTRIES.map((c, i) => (
          <Reveal key={c.id} delay={(i % 2) * 0.1} className={i % 2 ? "lg:mt-16" : ""}>
            <article data-testid={`destination-card-${c.id}`} className="group">
              <div className="overflow-hidden rounded-xl border border-slate-900/10 aspect-[4/3]">
                <img src={c.img} alt={`${c.name} — study destination`}
                  className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]" />
              </div>
              <div className="flex items-end justify-between mt-5">
                <div className="flex items-baseline gap-3">
                  <span className="font-heading text-lg text-amber-600 font-semibold">0{i + 1}</span>
                  <h3 className="font-heading text-2xl sm:text-3xl font-bold text-[#0B192C]">{c.name}</h3>
                </div>
                <span className="text-[10px] font-bold uppercase tracking-widest text-amber-700 bg-amber-100 rounded px-2 py-0.5">{c.flag}</span>
              </div>
              <ul className="mt-3 space-y-1.5">
                {c.highlights.map((h) => (
                  <li key={h} className="flex gap-2 text-[13px] text-slate-600 leading-snug">
                    <Check className="w-3.5 h-3.5 text-amber-600 mt-0.5 shrink-0" /> {h}
                  </li>
                ))}
              </ul>
              <div className="flex items-center justify-between mt-4 pt-4 border-t border-slate-900/10">
                <p className="text-xs font-semibold text-slate-500">Tuition: {c.fees}</p>
                <button data-testid={`destination-enquire-${c.id}`}
                  onClick={() => onEnquire({ destination: c.flag === "USA" ? "USA" : c.flag, service: `Study Abroad — ${c.flag}` })}
                  className="group/btn inline-flex items-center gap-1.5 text-sm font-semibold text-[#0B192C] hover:text-amber-700 transition-colors">
                  Enquire for {c.flag} <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover/btn:translate-x-0.5 group-hover/btn:-translate-y-0.5" />
                </button>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
